export default __webpack_public_path__ + "static/img-channel-thumbnail-first-6c7d3a127665624afbc8831f13d41303.avif";